// components/Layout.jsx
import React from 'react';
import Cabecalho from './Cabecalho'; // Seu componente de cabeçalho existente

const Layout = ({ children }) => {
  return (
    <div className="app-container">
      <Cabecalho />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;